/* eslint-disable object-curly-newline */
/**
 * 游戏介绍场景模块
 * @param {object} kaplay - KAPLAY引擎实例
 */
export function createIntroScene(kaplay) {
    const { add, sprite, pos, anchor, scale, z, width, height, text, color, wait, setCursor, go } = kaplay;

    /**
     * 初始化介绍场景
     */
    function initIntro() {
        // 设置鼠标为禁止标识
        setCursor('not-allowed');

        // 添加背景
        add([sprite('bg'), pos(0, 0), scale(1.2), anchor('topleft'), z(-1)]);

        // 猫咪角色（中央位置）
        add([sprite('cat'), pos(150, 300), anchor('center'), scale(0.9), z(1)]);

        // 第一个文字提示："用手指按住"
        const textWithBg1 = add([sprite('textBg'), pos(width() / 1.5, 120), anchor('center'), z(1)]);
        textWithBg1.add([text('用手指按住', { size: 24, font: 'sans-serif' }), anchor('center'), color(0, 0, 0), z(2)]);

        // 第二个文字提示："跟随箭头滑动" (500毫秒后显示)
        let textBg2;

        // 手指图标（底部中央偏左）
        const hand = add([sprite('hand'), pos(width() / 2 + 80, height() - 200), anchor('center'), scale(0.8), kaplay.rotate(0), z(2)]);

        // 触摸点指示器 (0-500毫秒显示)
        const touchIndicator = add([
            sprite('touch1'),
            pos(width() / 2 + 18, height() - 250),
            anchor('center'),
            scale(0.7),
            z(3),
            kaplay.opacity(0.9)
        ]);

        // 500毫秒后隐藏前三个元素
        wait(0.5, () => {
            textWithBg1.destroy();
            touchIndicator.destroy();
        });

        // 500毫秒后开始第二阶段动画
        wait(0.5, () => {
            // 第二个文字提示："跟随箭头滑动"
            textBg2 = add([sprite('textBg'), pos(width() / 1.5, 120), anchor('center'), z(1)]);
            add([text('跟随箭头滑动', { size: 24, font: 'sans-serif' }), pos(width() / 1.5, 120), anchor('center'), color(0, 0, 0), z(2)]);

            // 右滑动箭头
            const swipeRight = add([
                sprite('swipeR'),
                pos(width() / 2 + 80, height() - 285),
                anchor('center'),
                scale(1),
                z(3),
                kaplay.opacity(0.9)
            ]);

            // 左滑动箭头
            const swipeLeft = add([
                sprite('swipeL'),
                pos(width() / 2 + 80, height() - 300),
                anchor('center'),
                scale(1),
                z(3),
                kaplay.opacity(0)
            ]);

            // 开始同步循环动画
            let isStateA = true; // true: 默认状态, false: 切换状态
            let switchStartTime = kaplay.time(); // 记录状态切换开始时间
            const switchDuration = 4.5; // 状态切换持续时间（秒）

            /**
             * 使用 easeInCubic 计算下次切换的等待时间
             * @returns {number} 等待时间（秒）
             */
            function getNextSwitchDelay() {
                // 计算从切换开始到现在的时间进度 (0-1)
                const elapsed = kaplay.time() - switchStartTime;
                const progress = Math.min(elapsed / switchDuration, 1);

                // 使用 easeInCubic：前面慢(进度接近0)，后面快(进度接近1)
                const easedProgress = kaplay.easings.easeInCubic(progress);

                // 映射到等待时间：前面慢(0.8秒)，后面快(0.05秒)
                return 0.8 - easedProgress * 0.75;
            }

            /**
             * 同步循环动画函数
             */
            function syncLoop() {
                if (isStateA) {
                    // 状态A -> 状态B (立即切换所有属性)
                    hand.pos = kaplay.vec2(width() / 2 + 130, height() - 240);
                    hand.angle = 45;
                    swipeRight.opacity = 0;
                    swipeLeft.opacity = 0.9;
                    textBg2.flipX = true;

                    isStateA = false;
                } else {
                    // 状态B -> 状态A (立即切换所有属性)
                    hand.pos = kaplay.vec2(width() / 2 + 80, height() - 200);
                    hand.angle = 0;
                    swipeRight.opacity = 0.9;
                    swipeLeft.opacity = 0;
                    textBg2.flipX = false;

                    isStateA = true;
                }

                // 计算下次切换的等待时间
                const nextDelay = getNextSwitchDelay();

                // 等待计算出的时间后继续循环
                wait(nextDelay, () => {
                    syncLoop();
                });
            }

            // 开始循环
            syncLoop();
        });

        // 5秒后切换到游戏场景
        wait(5, () => {
            go('game');
        });
    }

    return { initIntro };
}
